// extracted by mini-css-extract-plugin
module.exports = {"container":"Badge_container__god_h","badge":"Badge_badge__1waxq","trophy_icon":"Badge_trophy_icon__3fHgB"};